import { HTTP_AP_ListAffiliates_ForTable_Request_Filter } from '@api-new/companyservice';
import { AffiliateTableRowModel } from '@platform/affiliate/models/affiliate-table.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const affiliateTableFilterDefaults: HTTP_AP_ListAffiliates_ForTable_Request_Filter = {
  nameContains: undefined,
};

export const affiliateTableRowDefinition: TableRowDefinitionModel<AffiliateTableRowModel>[] = [
  {
    columnLabel: 'Name',
    columnKey: 'name',
    type: RowDefinitionTypeEnum.Text,
    isFrozen: true,
  },
  {
    columnLabel: 'Logo',
    columnKey: 'logo',
    type: RowDefinitionTypeEnum.Image,
    width: {
      min: '10rem',
      max: '10rem',
    },
  },
  {
    columnLabel: 'ID',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '10rem',
      max: '50rem',
    },
  },
];
